/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CandidateCompany,
    CandidateCompanyFromJSON,
    CandidateCompanyFromJSONTyped,
    CandidateCompanyToJSON,
    Event,
    EventFromJSON,
    EventFromJSONTyped,
    EventToJSON,
} from './';

/**
 * Item ligero de oferta para listados vista candidato [P_A_02] [P_A_11]
 * @export
 * @interface CandidateOfferItem
 */
export interface CandidateOfferItem {
    /**
     * 
     * @type {number}
     * @memberof CandidateOfferItem
     */
    id?: number;
    /**
     * true: viene el company, false: viene el company_name
     * @type {boolean}
     * @memberof CandidateOfferItem
     */
    displayCompanyName?: boolean;
    /**
     * 
     * @type {CandidateCompany}
     * @memberof CandidateOfferItem
     */
    company?: CandidateCompany;
    /**
     * 
     * @type {string}
     * @memberof CandidateOfferItem
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateOfferItem
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateOfferItem
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateOfferItem
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateOfferItem
     */
    expireAt?: string;
    /**
     * normal, fct, dual
     * @type {string}
     * @memberof CandidateOfferItem
     */
    modality?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateOfferItem
     */
    date?: string;
    /**
     * id tipo de contrato
     * @type {number}
     * @memberof CandidateOfferItem
     */
    contractType?: number;
    /**
     * duración del trabajo
     * @type {string}
     * @memberof CandidateOfferItem
     */
    length?: string;
    /**
     * bruto año, neto al mes, ...
     * @type {string}
     * @memberof CandidateOfferItem
     */
    salaryType?: string;
    /**
     * 
     * @type {number}
     * @memberof CandidateOfferItem
     */
    salaryMin?: number;
    /**
     * 
     * @type {number}
     * @memberof CandidateOfferItem
     */
    salaryMax?: number;
    /**
     * 
     * @type {string}
     * @memberof CandidateOfferItem
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateOfferItem
     */
    state?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CandidateOfferItem
     */
    isRemoteProcess?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CandidateOfferItem
     */
    presence?: string;
    /**
     * esto es para cuando el alumno está inscrito [P_A_12], si no viene vacio
     * @type {Array<Event>}
     * @memberof CandidateOfferItem
     */
    events?: Array<Event>;
    /**
     * Estado actual de la candidatura, si no esta inscrito viene null
     * @type {string}
     * @memberof CandidateOfferItem
     */
    status?: string;
    /**
     * tipo de horario
     * @type {number}
     * @memberof CandidateOfferItem
     */
    schedule?: number;
    /**
     * el curso del alumno es compatible con la oferta
     * @type {boolean}
     * @memberof CandidateOfferItem
     */
    academicMatching?: boolean;
}

export function CandidateOfferItemFromJSON(json: any): CandidateOfferItem {
    return CandidateOfferItemFromJSONTyped(json, false);
}

export function CandidateOfferItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidateOfferItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'displayCompanyName': !exists(json, 'display_company_name') ? undefined : json['display_company_name'],
        'company': !exists(json, 'company') ? undefined : CandidateCompanyFromJSON(json['company']),
        'companyName': !exists(json, 'company_name') ? undefined : json['company_name'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'externalUrl': !exists(json, 'external_url') ? undefined : json['external_url'],
        'expireAt': !exists(json, 'expire_at') ? undefined : json['expire_at'],
        'modality': !exists(json, 'modality') ? undefined : json['modality'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'contractType': !exists(json, 'contract_type') ? undefined : json['contract_type'],
        'length': !exists(json, 'length') ? undefined : json['length'],
        'salaryType': !exists(json, 'salary_type') ? undefined : json['salary_type'],
        'salaryMin': !exists(json, 'salary_min') ? undefined : json['salary_min'],
        'salaryMax': !exists(json, 'salary_max') ? undefined : json['salary_max'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'isRemoteProcess': !exists(json, 'is_remote_process') ? undefined : json['is_remote_process'],
        'presence': !exists(json, 'presence') ? undefined : json['presence'],
        'events': !exists(json, 'events') ? undefined : ((json['events'] as Array<any>).map(EventFromJSON)),
        'status': !exists(json, 'status') ? undefined : json['status'],
        'schedule': !exists(json, 'schedule') ? undefined : json['schedule'],
        'academicMatching': !exists(json, 'academic_matching') ? undefined : json['academic_matching'],
    };
}

export function CandidateOfferItemToJSON(value?: CandidateOfferItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'display_company_name': value.displayCompanyName,
        'company': CandidateCompanyToJSON(value.company),
        'company_name': value.companyName,
        'title': value.title,
        'text': value.text,
        'external_url': value.externalUrl,
        'expire_at': value.expireAt,
        'modality': value.modality,
        'date': value.date,
        'contract_type': value.contractType,
        'length': value.length,
        'salary_type': value.salaryType,
        'salary_min': value.salaryMin,
        'salary_max': value.salaryMax,
        'city': value.city,
        'state': value.state,
        'is_remote_process': value.isRemoteProcess,
        'presence': value.presence,
        'events': value.events === undefined ? undefined : ((value.events as Array<any>).map(EventToJSON)),
        'status': value.status,
        'schedule': value.schedule,
        'academic_matching': value.academicMatching,
    };
}


